import React, { useState } from 'react'; 
import { Link } from 'react-router-dom'; 
import hamburgerIcon from '../assets/images/ham.svg'; 
import closeIcon from '../assets/images/close.svg'; 

const Projects = () => { 
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Projects data
  const projects = [
    {
      name: "CybervisionX",
      description: "This is a description of the CybervisionX project. It focuses on innovative solutions for web security and management.",
      githubLink: "https://github.com/itachiuchiha241/CybervisionX"
    },
    {
      name: "Car-Management-System",
      description: "This project involves managing a car rental system, including features such as booking, payment processing, and user management.",
      githubLink: "https://github.com/itachiuchiha241/Car-Management-System1"
    },
  ];

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div>
      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          {isSidebarOpen && (
            <img
              src={closeIcon}
              alt="Close Sidebar"
              className="close-btn"
              onClick={closeSidebar}
            />
          )}
        </div>
        <ul className="sidebar-links">
          <li><Link to="/" onClick={closeSidebar}>Home</Link></li>
          <li><Link to="/about" onClick={closeSidebar}>About</Link></li>
          <li><Link to="/skills" onClick={closeSidebar}>Skills</Link></li>
          <li><Link to="/projects" onClick={closeSidebar}>Projects</Link></li>
          <li><Link to="/contact" onClick={closeSidebar}>Contact</Link></li>
        </ul>
      </div>

      {/* Hamburger Menu */}
      {!isSidebarOpen && (
        <img
          src={hamburgerIcon}
          alt="Open Sidebar"
          className="hamburger"
          onClick={toggleSidebar}
        />
      )}

      {/* Header Section */}
      <header>
        <nav className="navbar navbar-expand-lg">
          <div className="left">
            <Link to="/" className="portfolio-link">
              <span className="purple">P</span>rem Portfolio
            </Link>
          </div>
          <div className="right ml-auto">
            <ul className="navbar-nav">
              <li className="nav-item"><Link className="nav-link" to="/about">About</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/skills">Skills</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/projects">Projects</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/contact">Contact me</Link></li>
            </ul>
          </div>
        </nav>
      </header>

      {/* Projects Section */}
      <section className="projects-section">
        <h2>My Projects</h2>
        <div className="projects-container">
          {projects.map(({ name, description, githubLink }) => (
            <div className="project-box" key={name}>
              <h3>{name}</h3>
              <p>{description}</p>
              {githubLink && (
                <a href={githubLink} className="visit-github" target="_blank" rel="noopener noreferrer">
                  Visit GitHub
                </a>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Footer Section */}
      <footer>
        <div className="footer">
          <div className="first">
            <h3>Prem's Developer Portfolio</h3>
            <p>Building innovative solutions for the web, one project at a time.</p>
          </div>
          <div className="second">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/skills">Skills</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="third">
            <h4>Connect with me:</h4>
            <ul>
              <li>
                <a href="https://github.com/itachiuchiha241" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-github"></i> GitHub
                </a>
              </li>
              <li>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin"></i> LinkedIn
                </a>
              </li>
              <li>
                <a href="mailto:prempawar241@gmail.com">
                  <i className="fas fa-envelope"></i> Email Me
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-rights">
          <p className="mb-0">&copy; 2025 Prem's Portfolio. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Projects;
